import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { WebApiService } from '../../shared/services/web-api.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import * as html2canvas from 'html2canvas';
import { Observable, Observer } from 'rxjs';
import { StorageService } from '../../shared/services/storage.service';
import { API_ENDPOINTS, API_FUNCTIONS } from '../../shared/constant/apiEndpoint.constant';
import { environment } from '../../../environments/environment';
import { NodeService } from '../../shared/services/node.service';
import { MuteService } from '../../shared/services/mute.service';

@Component({
  selector: 'app-badges',
  templateUrl: './badges.component.html',
  styleUrls: ['./badges.component.css']
})
export class BadgesComponent implements OnInit {
  public url: any;
  base64Image: any;
  public dataURL: any;
  public twitterShareApi = 'https://twitter.com/intent/tweet?text=Check out my Certificate&url=';
  public fbShareAPi = 'http://www.facebook.com/sharer.php?u=';
  public linkedInAPi = 'https://www.linkedin.com/shareArticle?mini=false&url='
  public downloadUrl = environment.apiUrl + API_ENDPOINTS.COMMON_ENDPOINT;
  public loginToken = this.storageService.getFromSessioStorage('loginToken');
  public wsfunction = API_FUNCTIONS.MY_BADGES;
  public allAudioTags: any;
  public userDtls: any;
  public profileFulltName:string = '';
  public loading = true;
  public badgeData: any;
  public profileAudio: any;

  @ViewChild('myCanvas') myCanvas: ElementRef;
  @ViewChild('imgId') imgTag: ElementRef;
  public context: CanvasRenderingContext2D;
  constructor(private bsModalRef: BsModalRef,
    private api: WebApiService,
    private modalService: BsModalService,
    private storageService: StorageService,
    private nodeService: NodeService,
    private muteService: MuteService) { }

  ngOnInit() {
    this.nodeService.addNode({ modalopen: true });
    // this.muteService.muteFun();
    this.loginToken = this.storageService.getFromSessioStorage('loginToken');
    this.userDtls = this.storageService.getFromSessioStorage('userInfo');
    this.profileFulltName = this.userDtls.first_name +" "+this.userDtls.last_name;

    this.loadBadges();

    this.loadAudio(0);
  }

  public closeCertificate() {
    this.bsModalRef.hide();
  }

  /**
   * 
   * method for showing the user certificate
   */
   loadBadges() {
    const requestDataMyLearning = {
      endPoint: API_ENDPOINTS.COMMON_ENDPOINT,
      data: {
        token: this.loginToken
      },
      params: {
        token: this.loginToken,
        function: API_FUNCTIONS.MY_BADGES,
        format: 'json'
      }
    };
    this.api.postApiCall(requestDataMyLearning).subscribe(
      (response: any) => {

        this.modalService.hide(this.modalService.getModalsCount());
        this.badgeData = response.badges;
        this.loading = false;
        console.log(response);
      }, (error) => {
        this.loading = false;
        this.modalService.hide(this.modalService.getModalsCount());
      });
  }

  public shareOnTwitter(badge) {
    var url = badge.image_url;
    var title = "Badge Earned "+badge.name;
    var description = badge.description;
    let twitterShareUrl = encodeURIComponent(environment.apiUrl+'/twitter_share.php?hash='+badge.uniquehash+'&img_url=' + url+"&title="+title+"&description="+description);
    twitterShareUrl = this.twitterShareApi + twitterShareUrl;
    window.open(twitterShareUrl, 'twitter-popup', 'toolbar=0,status=0,width=600,height=350'); return false;
  }

  public shareOnFb(badge) {
    var url = badge.image_url;
    var title = "Badge Earned "+badge.name;
    var description = badge.description;
    let facebookShareUrl = encodeURIComponent(environment.apiUrl+'/facebook_share.php?hash='+badge.uniquehash+'&img_url=' + url+"&title="+title+"&description="+description);
    facebookShareUrl = this.fbShareAPi + facebookShareUrl;
    window.open(facebookShareUrl, 'sharer', 'toolbar=0,status=0,width=600,height=350'); return false;
  }

  public shareOnLinkedIn(badge) {
    var url = badge.image_url;
    var title = "Badge Earned "+badge.name;
    var description = badge.description;
    this.url = url; 
    let linkedInUrl = encodeURIComponent(environment.apiUrl+'/linkedin_share.php?hash='+badge.uniquehash+'&img_url=' + url+"&title="+title+"&description="+description);
    linkedInUrl = this.linkedInAPi + linkedInUrl;
    window.open(linkedInUrl, 'sharer', 'toolbar=0,status=0,width=600,height=350'); return false;
  }

  loadAudio(eleNo) {
    this.profileAudio = <HTMLAudioElement>document.getElementById('myProfileAudio');
    /**
     * ToDo:
     */
    switch (eleNo) {
      case 0: this.profileAudio.src = '../../assets/audio/myprofile/badges/bage_intro_audio.mp3';
        break;
      case 1: this.profileAudio.src = '../../assets/audio/shared/Close_Button.mp3';
        break;
      case 2: this.profileAudio.src = '../../assets/audio/myprofile/badges/linkedIn_share_badge.mp3';
        break;
      case 3: this.profileAudio.src = '../../assets/audio/myprofile/badges/twitter_share_badge.mp3';
        break;
      case 4: this.profileAudio.src = '../../assets/audio/myprofile/badges/facebook_share_badge.mp3';
        break;
      case 5: this.profileAudio.src = '../../assets/audio/myprofile/badges/DownloadCertificateButton.mp3'
        break;
      default: this.profileAudio.src = '';
    }
  }
  public closeModal() {
    this.bsModalRef.hide();
    this.nodeService.addNode({ modalopen: false });
  }
}



// WEBPACK FOOTER //
// ./src/app/myprofile/badges/badges.component.ts